import Layout from '@/components/layout/Layout'
import { LEGAL_DOCS } from '@/data/en'
import ContactPage from '@/pages/ContactPage'
import GuidePage from '@/pages/GuidePage'
import HomePage from '@/pages/HomePage'
import LegalPage from '@/pages/LegalPage'
import NotFoundPage from '@/pages/NotFoundPage'
import UpdatesPage from '@/pages/UpdatesPage'

// Paths come from the English copy; every language shares them.
/** Exported apart from the router so tests can mount it with createMemoryRouter. */
export const routes = [
  {
    element: <Layout />,
    children: [
      { path: '/', element: <HomePage /> },
      { path: '/contact', element: <ContactPage /> },
      { path: '/updates', element: <UpdatesPage /> },
      { path: '/guide', element: <GuidePage /> },
      ...LEGAL_DOCS.map((doc) => ({
        path: doc.path,
        element: <LegalPage path={doc.path} />,
      })),
      { path: '*', element: <NotFoundPage /> },
    ],
  },
]
